import Home from './pages/home';
import NfProcess from './pages/nfProcess';
import PaymentProcess from './pages/paymentProcess';
import ScheduleList from './pages/schedule';
import View from './pages/view';

import {ENUM_PERMISSIONS} from '@presentation/modules/route/helpers';

export const formattedRoute = (route: string, value?: any) => {
    return route.replace('/:key', `/${value}`).replace('/:id', `/${value}`);
};

const hostname = window.location.protocol + '//' + window.location.host + '/';

export enum routes {
    HOME = "/finance",
    SCHEDULE = "/schedule",
    SCHEDULE_VIEW = '/schedule/:id',
}

export const permissions = [
    ENUM_PERMISSIONS.admin,
    ENUM_PERMISSIONS.secretary,
    ENUM_PERMISSIONS.surgeon,
];

export const paths = [
    {
        label: 'Agenda',
        key: routes.SCHEDULE,
        icon: hostname + 'icons/schedule.svg',
        element: <ScheduleList />,
        permission: permissions,
        children: null,
    },
    {
        label: 'Financeiro',
        key: routes.HOME,
        icon: hostname + 'icons/finance.svg',
        element: <Home />,
        permission: permissions,
        children: null,
    },
    {
        label: '',
        key: routes.SCHEDULE_VIEW,
        icon: null,
        element: <View />,
        permission: permissions,
        children: null,
    },
    {
        label: '',
        key: '/paymentprocess',
        icon: null,
        element: <PaymentProcess />,
        permission: permissions,
        children: null,
    },
    {
        label: '',
        key: '/nfprocess',
        icon: null,
        element: <NfProcess />,
        permission: permissions,
        children: null,
    },
];
